import { useEffect } from "react";
import { useImmer } from "use-immer";

import {
  GetIntegrationResponseBodyType,
  IntegrationName,
} from "@intelligems/ig-types";

import { QueryOptions } from "../../types/react-query";

import { useGetIntegrations } from "./get-integrations";

export const useGetIntegration = <I>(
  name: IntegrationName,
  options?: QueryOptions<GetIntegrationResponseBodyType, Error>
) => {
  const integrations = useGetIntegrations(undefined, options);
  const [integration, setIntegration] = useImmer<I | undefined>(undefined);

  useEffect(() => {
    if (integrations.isSuccess) {
      if (integrations.data?.integrations?.length) {
        const google = integrations.data.integrations.find(
          (integration) => integration.name === name
        );
        setIntegration((google as I) || undefined);
      }
    }
  }, [integrations.isSuccess, integrations.data]);

  return {
    ...integrations,
    data: integration || null,
  };
};
